<div class="mt-5 mb-5">
  <h2 class="text-center">Etwas ist schiefgelaufen...</h2>
  <p class="text-muted text-center">Der Shop von {{shop.current.name}} ist nicht richtig konfiguriert.</p>
  <img class="img-fluid checkout-image mx-auto d-block" src="assets/images/payment-error.png">
</div>
